// 知识接口

import request from "@/util/request";

export function list(param) {
    return request({
        url: '/sample',
        method: 'get',
        params: param
    })
}

export function saveOrUpdate(news) {
    return request({
        url: '/sample',
        method: 'post',
        data: news
    })
}

export function getById(newsId) {
    return request({
        url: '/sample/getById/' + newsId,
        method: 'get'
    })
}

export function deleteNews(newsId) {
    return request({
        url: '/sample/delete',
        method: 'delete',
        params: {
            id: newsId
        }
    })
}

export function uploadCover(data) {
    return request({
        url: '/sample/uploadCover',
        method: 'post',
        data: data
    })
}